/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import clsx from "clsx";

import { apiGetCancellation } from "../../lib/api/session";

import { XIcon } from "@heroicons/react/outline";
import { IoChevronBack } from "react-icons/io5";

import Loading from "../Shared/Loading";
// import EngageHeader from "../Builders/Header/EngageHeader";

const Cancelled = () => {
  const router = useRouter();
  const { client, id } = router.query;
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      async function fetchData() {
        setLoading(true);
        try {
          const result = await apiGetCancellation(id);

          if (result && result.meeting?.cancelNoticePublic) {
            let content;
            try {
              content = JSON.parse(result.meeting.cancelNoticePublic);
            } catch {
              content = "No Notice Available";
            }

            setData(`<!DOCTYPE html>
              <html lang="en">
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Document</title>
                <link rel="stylesheet" href="/styles/tinymce.css">
              </head>
              <body>
                ${content}
              </body>
              </html>`);
          } else {
            // Missing or invalid cancelNoticePublic
            setData(`<!DOCTYPE html>
              <html lang="en">
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Document</title>
                <link rel="stylesheet" href="/styles/tinymce.css">
              </head>
              <body>
                No Notice Available
              </body>
              </html>`);
          }
        } catch (error) {
          // API call failed
          setData(`<!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Document</title>
              <link rel="stylesheet" href="/styles/tinymce.css">
            </head>
            <body>
              No Notice Available
            </body>
            </html>`);
        } finally {
          setLoading(false);
        }
      }

      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="pb-sm antialiased w-full 2xl:max-w-7/8 2xl:mx-auto">
      {data && (
        <div
          className={clsx(
            "hidden md:block max-w-full 2xl:max-w-7/8 mx-auto px-4 sm:px-6 md:px-8 pt-6 bg-white z-40",
          )}
        >
          <div className="pb-2 border-b border-gray-400 flex justify-end mt-2">
            <XIcon
              className="h-5 w-5 md:h-6 md:w-6 xl:h-8 xl:w-8 2xl:h-10 2xl:w-10 text-gray-800 cursor-pointer hover:text-delete-btn transform duration-200 hover:rotate-180"
              aria-hidden="true"
              onClick={() => {
                const newPath = `${process.env.NEXT_PUBLIC_BASE_URL}/engage-v2/${client}/agendas`;
                router.replace(newPath);
              }}
            />
          </div>
        </div>
      )}

      {/* Mobile header */}
      {data && (
        <div className="md:hidden px-4 sm:px-6 pt-2 bg-white">
          <div className="pb-1 border-b border-gray-400">
            <div className="relative flex items-center">
              <IoChevronBack
                className="h-6 w-6 text-gray-800 cursor-pointer hover:text-gray-400"
                aria-hidden="true"
                onClick={() => {
                  const newPath = `${process.env.NEXT_PUBLIC_BASE_URL}/engage-v2/${client}/agendas`;
                  router.replace(newPath);
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Agenda Details */}
      <div className="w-full h-screen overflow-y-auto">
        {data && (
          <iframe
            id="myIframe"
            srcDoc={data}
            style={{ width: "100%", height: "100%", border: "none" }}
            sandbox="allow-same-origin"
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default Cancelled;
